import * as PropertyBucket from '../../Properties/Properties';

export function sendLog(eventType, contextType, value, fullBody) {

    // Default body for a single entry
    const body = {
        eventType: eventType ? eventType : "FILE_DOWNLOADED",
        eventContexts: [
            {
                contextType: contextType ? contextType : "FILE_NAME",
                value: value ? value : "Parameter is missing"
            }
        ]
    };

    return fetch(PropertyBucket.sendLogs(), {
        method: 'POST',
        body: JSON.stringify(fullBody || body),
        headers: new Headers({
            'content-type': 'application/json',
            'Accept': 'application/json, application/xml, text/plain, text/html, */*',
            'Access-Control-Allow-Origin': '*',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        })
    });
}